"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../events/application-events.service");
const i2 = require("../../../../../projects/angular-sdk/src/4d-mapper.service");
const i3 = require("../../../commons/map.service");
const i4 = require("../../../v2/commons/stream-data.service");
const i5 = require("../../../v2/commons/map-data.service");
const i6 = require("../../../v2/commons/file-data.service");
DEBUG_1.DEBUG.open('/xs/service/ui-manager');
const identify_interface_1 = require("../../interfaces/identify.interface");
const Constants_1 = require("@src/app/commons/Constants");
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("@src/app/commons/map.service");
const event_listener_interface_1 = require("../../interfaces/event-listener.interface");
const application_events_service_1 = require("../events/application-events.service");
const operators_1 = require("rxjs/operators");
const stream_data_service_1 = require("@src/app/v2/commons/stream-data.service");
const map_data_service_1 = require("@src/app/v2/commons/map-data.service");
const file_data_service_1 = require("@src/app/v2/commons/file-data.service");
class XsIncomingDataService {
    constructor(applicationEvents, fourD, mapService, streams, mapData, fileData) {
        this.applicationEvents = applicationEvents;
        this.fourD = fourD;
        this.mapService = mapService;
        this.streams = streams;
        this.mapData = mapData;
        this.fileData = fileData;
        this.__ID = null;
        this.__EVENTS = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugCounter = 0;
        // core data
        this.length = 0;
        // current batch's max number
        this.lengthPhotosBatched = 0;
        // current photos in the queue
        this.lengthPhotos = 0;
        this.lengthPhotosUploading = 0;
        this.lengthPhotosProcessing = 0;
        // percentage calculated lengths
        this.percentFactor = 0;
        this.percentDone = 0;
        this.percentWorking = 0;
        this.items = [];
        this.photos = [];
        this.untyped = [];
        this._log = {};
        this.state = {};
        // subject for incoming data queries
        this.incomingData$ = new rxjs_1.Subject();
        this._incomingData$ = this.incomingData$.asObservable().pipe(operators_1.debounceTime(1000));
        DEBUG_1.DEBUG.log('/xs/service/incoming-data');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        if (this.debug) {
            console.log("%c incomingDataManager CONSTRUCTOR() ", Constants_1.Constants._yellow, this.debug);
        }
        // this.add( new Dataset(this.fourD.V).set({ "id":99999999990, "name": "First test file", "__state":"transform", "__test": true }));
        // this.add( new Dataset(this.fourD.V).set({ "id":99999999991, "name": "Second test file", "__state":"file", "__test": true }));
        this.incomingData$.pipe(operators_1.debounceTime(2000)).subscribe(s => {
        });
        // A jpeg will throw this several times, befin, mid end upload beging and end processing
        this.streams.fileEvents.subscribe(s => {
            if (this.__isDatasetForCurrentScene(s.item)) {
                // console.log('## %c [file] %c for current scene', Constants._purple, Constants._white, s );
                this.__log('file', s);
                if (s.event == 'processing_finished' && s.item.dataType.uid == 'photo') {
                    // this.remove(s.item);
                }
                else if (s.event == 'ADD') {
                    // console.log('## %c [file] %c for current scene ADD', Constants._purple, Constants._white, s );
                    this.add(s.item);
                }
            }
            else {
                // console.log('## %c [file] %c for other scene', Constants._purple, Constants._white, s, s.item.folder.id, this.mapService.scene.folder.id );
            }
        });
        /*
        this.streams.folderEvents.subscribe(s => {
          console.log('## [folder]', s );
        });
    
        this.streams.sceneEvents.subscribe(s => {
          console.log('## [scene]', s, this._log );
        });
    
        this.streams.annotationEvents.subscribe(s => {
          console.log('## [annotation]', s );
        });
    
        this.mapData.sceneLayers.events.subscribe(s => {
          console.log('## [layer-mapdata]', s );
        });
    
        this.mapData.scene.events.subscribe(s => {
          console.log('## [scene-mapdata]', s );
        });
        */
        /*
        this.fileData.processingItems.events.subscribe(s => {
          console.log('## [process]', s );
        });
    
        
        this.fileData.uploadingFiles.events.subscribe(s => {
          console.log('## [upload]', s );
        });
    
        this.fileData.uploadingQueue.events.subscribe(s => {
          console.log('## [upload-queue]', s );
        });
        */
        // listen for uploads happening
        this.fourD.uploadsRunningObservable.subscribe(s => {
            // console.log('## %c [upload-obs] %c ', Constants._purple, Constants._white, s );
            this.uploadingUpdate(s);
        });
        // listen to sockets for task_updates
        // this.fourD.onSocketCommand('task_update').subscribe(s => {
        //   console.log('## %c [task-update-socket] %c ', Constants._purple, Constants._white, s );
        //   this.processingUpdate(s);
        // });
        this.fourD.runningTasksObservable.subscribe(s => {
            // console.log('## %c [running-obs] %c', Constants._purple, Constants._white, s );
            this.processingUpdate(s);
        });
    }
    __log(key, s) {
        const now = Math.round(performance.now());
        const item = s.item;
        const event = s.event;
        const id = item ? item.id : 'null';
        const name = item ? item.name : 'null';
        const mode = s.args && s.args.mode ? s.args.mode : 'null';
        const socket = s.args && s.args.socket ? s.args.socket : 'null';
        const status = s.item ? s.item.status : 'null';
        const incomplete = s.item ? s.item.incomplete : 'null';
        const entry = now + ' [' + event + '] m=[' + mode + '] so=[' + socket + '] st=[' + status + '] i=[' + incomplete + ']';
        if (!this._log['all']) {
            this._log['all'] = {};
        }
        if (!this._log['all'][id]) {
            this._log['all'][id] = [];
            this._log['all'][id].push(now + ' {' + name + '} [' + id + '] ---------' + '(' + key + ')');
        }
        if (!this._log[key]) {
            this._log[key] = {};
        }
        if (!this._log[key][id]) {
            this._log[key][id] = [];
            this._log[key][id].push(now + ' {' + name + '} [' + id + '] ---------');
        }
        this._log['all'][id].push(entry + '(' + key + ')');
        this._log[key][id].push(entry);
    }
    __isDatasetForCurrentScene(item) {
        if (!this.mapService && !this.mapService.scene && !item && !item.folder) {
            return false;
        }
        return item.folder.id == this.mapService.scene.folder.id;
    }
    _updateLengths() {
        // const tests = ['test1.jpg','test2.JPG','bongo.yalla','some.jp2','test3.jpeg','test4.Jpg'];
        const arr = ['.jpg', '.jpeg'];
        const findStr = (arr, str) => arr.some(e => str.toLowerCase().includes(e.toLowerCase()));
        this.photos = this.items.filter(d => {
            return (d.dataType && d.dataType.uid == 'photo') || (!d.dataType && findStr(arr, d.name));
        });
        this.length = this.items.length;
        this.lengthPhotos = this.photos.length;
        this.lengthPhotosUploading = 0;
        this.lengthPhotosProcessing = 0;
        this.photos.forEach(p => {
            p['__name_based_photo'] = true;
            if (this.state[p.id]) {
                if (this.state[p.id] == 'process-working' || this.state[p.id] == 'process-ready') {
                    // console.log('## photo ['+p.id+'] state [process]',p.id,this.state[p.id]);
                    this.lengthPhotosProcessing++;
                }
                else if (this.state[p.id] == 'upload-working') {
                    // console.log('## photo ['+p.id+'] state',p.id,this.state[p.id]);
                    this.lengthPhotosUploading++;
                }
                else {
                    // console.log('## photo ['+p.id+'] state ??',p.id,this.state[p.id]);
                }
            }
            else {
                // console.log('## photo ['+p.id+'] NO state',p.id,this.state[p.id]);
            }
        });
        if (this.lengthPhotos > this.lengthPhotosBatched) {
            this.lengthPhotosBatched = this.lengthPhotos;
        }
        if (this.lengthPhotos == 0) {
            this.lengthPhotosBatched = 0;
        }
        this.percentFactor = this.lengthPhotosBatched ? 100 / this.lengthPhotosBatched : 1;
        let sofar = this.lengthPhotosBatched - this.lengthPhotos;
        this.percentDone = (this.percentFactor * (sofar));
        this.percentWorking = (this.percentFactor * (sofar + this.lengthPhotosProcessing));
    }
    _getItem(id) {
        return this.items.find(f => f.id == id);
    }
    _getItemIdFromEvent(s) {
        let ret = null;
        if (s.task) {
            let check = s.task.dataset ? s.task.dataset.id : '' + parseInt(s.task.uid);
            ret = this.items.find(f => f.id == check);
        }
        if (!ret && s.dataset) {
            ret = this.items.find(f => f.id == s.dataset.id);
        }
        return ret ? ret.id : null;
    }
    _getStateFromEvent(s) {
        let ret = 'unknown';
        if (s.event) {
            if (s.event == 'start' || s.event == 'add') {
                ret = 'working';
            }
            else if (s.event == 'finished' || s.event == 'remove') {
                ret = 'ready';
            }
            else {
                ret = s.event;
            }
        }
        else if (s.status) {
            ret = s.status == 'started' ? 'working' : s.status;
        }
        return ret;
    }
    /* The main API */
    // add an item to our list of incoming files
    add(dataset = null, log = true) {
        if (dataset) {
            const find = this.items.find(f => f.id == dataset.id);
            if (find) {
                // if ( log ) { console.log('## %c add() %c already here', Constants._orange, Constants._white, dataset); }
            }
            else {
                this.items.push(dataset);
                // possible states: 'upload-working', 'upload-ready', 'process-working', 'process-ready', 'process-error'
                this.state[dataset.id] = dataset.incomplete ? 'upload-working' : 'upload-ready';
                // if ( log ) { console.log('## %c add() %c Added',Constants._orange, Constants._white, dataset); }
            }
            this._updateLengths();
        }
    }
    // add a bunch of items
    addAll(datasets = null) {
        if (datasets && datasets.length) {
            // console.log('## %c addAll() %c ',Constants._orange, Constants._white, datasets);
            datasets.forEach(ds => this.add(ds, false));
        }
    }
    // process an incoming file (start an ad-hoc processing job)
    process(dataset = null, transformType = null, service = null, dialog = null) {
        let datatypeId = null;
        // no incoming transform data type? But we know there are some? Pick from the top ...
        if (!transformType && dataset.dataType._adhocTransforms.length) {
            datatypeId = dataset.dataType._adhocTransforms[0].id;
        }
        else if (transformType) {
            datatypeId = transformType.id;
        }
        // find the type
        let type = dataset.dataType._adhocTransforms.find(f => f.id == datatypeId);
        if (this.debug) {
            console.log('## %c process() %c ', Constants_1.Constants._orange, Constants_1.Constants._white, dataset, datatypeId, type);
        }
        if (!type) {
            throw ('No transform datatype found');
        }
        this.state[dataset.id] = 'process-working';
        service.startAdHoc(dialog, dataset, type, true).subscribe(success => {
            if (this.debug) {
                console.log('## incomingData process success', success);
            }
            this.state[dataset.id] = 'process-ready';
        }, error => {
            if (this.debug) {
                console.log('## incomingData process error', error);
            }
            this.state[dataset.id] = 'process-error';
        });
    }
    // cancel an uploading file
    cancel(dataset = null) {
        if (this.debug) {
            console.log('## incomingData cancel', dataset);
        }
        this.remove(dataset);
    }
    // remove an incoming file (and make sure we don't add it to our list again in the future)
    remove(dataset = null) {
        if (this.debug) {
            console.log('## %c remove %c ', Constants_1.Constants._orange, Constants_1.Constants._white, dataset);
        }
        if (dataset) {
            dataset['__incoming_dismissed'] = true;
            dataset.saveObservable().subscribe();
            this.items = this.items.filter(ds => ds.id !== dataset.id);
            this._updateLengths();
            // if ( this.debug ) { console.log('## incomingData Removed',dataset); }
        }
    }
    // remove a list of things
    removeAll(datasets = null) {
        if (datasets && datasets.length) {
            datasets.forEach(ds => this.remove(ds));
        }
    }
    // create a new spanking list from querying files attached to a scene folder
    populateFromScene(scene = null) {
        if (!scene) {
            scene = this.mapService.scene;
        }
        const from = Date.now();
        const time = 14 * 24 * 60 * 60 * 1000; // fortnight
        const me = Date.now() - time;
        // const ts = 1632115478038;
        // console.log('## %c populateFromScene() %c ', Constants._orange, Constants._white, me, new Date(from), new Date(me), scene, scene.folder );
        // first fetch all files in the scene folder within the last 14 days
        this.fourD.V.searchByObject(_4d_mapper_1.Dataset).equals('folder', scene.folder).greaterThan('dateUpdated', me).sortBy('dateUpdated', true).limit(878).queryObservable().subscribe(value => {
            // find those with no transforms?
            let find = value.items.filter(v => (!v['__incoming_dismissed']) && (v.dataType && v.dataType._adhocTransforms && v.dataType._adhocTransforms.length) && (!v.transformIds || !v.transformIds.length || !v.transformIds[0]));
            if (this.debug) {
                console.log('## %c populateFromScene() %c Populate', Constants_1.Constants._orange, Constants_1.Constants._white, value.items, find);
            }
            this.addAll(find);
        }, error => {
            if (this.debug) {
                console.log('## populateFromScene() ERROR', error);
            }
        });
    }
    _incomingUpdate(key, s) {
        const id = this._getItemIdFromEvent(s);
        const item = this._getItem(id);
        if (item) {
            item.fetchObservable().subscribe();
        }
        else {
            if (this.debug) {
                console.log('## %c incoming [' + key + '] %c error ', Constants_1.Constants._blue, Constants_1.Constants._red, key, s, id, typeof id, item);
            }
            return;
        }
        this.state[id] = key + '-' + this._getStateFromEvent(s);
        if (s.task && s.task.dataset) {
            s.task.event = s.event;
            s.task.status = s.status;
            s.task.item = s.task.dataset;
            this.__log(key, s.task);
        }
        if (this.debug) {
            console.log('## %c incoming [' + key + '] %c ', Constants_1.Constants._blue, Constants_1.Constants._white, id, this._getStateFromEvent(s), s);
        }
        this._updateLengths();
        return item;
    }
    // listen out for uploading updates
    uploadingUpdate(s) {
        this._incomingUpdate('upload', s);
    }
    // listen out for job updates
    jobUpdate(s) {
        this._incomingUpdate('job', s);
    }
    // listen out for processing updates
    processingUpdate(s) {
        let item = this._incomingUpdate('process', s);
        // is it finished? Then remove from our list
        if (item && this.state[item.id] == 'process-ready') {
            // if not a photo (more specifically; if it's a zip that's unpacked other files), re-query for incoming files
            // console.log('## incomingData PROCESS finished', s );
            item['__auto_zoom_to'] = true;
            this.remove(item);
        }
    }
}
XsIncomingDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function XsIncomingDataService_Factory() { return new XsIncomingDataService(i0.ɵɵinject(i1.XsApplicationEventsService), i0.ɵɵinject(i2.FourDService), i0.ɵɵinject(i3.MapService), i0.ɵɵinject(i4.StreamDataService), i0.ɵɵinject(i5.MapDataService), i0.ɵɵinject(i6.FileDataService)); }, token: XsIncomingDataService, providedIn: "root" });
exports.XsIncomingDataService = XsIncomingDataService;
